/**
 * Override de authService para integración SaaS.
 *
 * Llama al endpoint SaaS (/api/v1/auth/login con JSON) en lugar del
 * endpoint TZU nativo (/api/token con form-encoded).
 * El token SaaS devuelto es un JWT que el bridge valida en cada llamada.
 */
import apiClient from './apiClient';
import axios from 'axios';

/**
 * Inicia sesión de usuario vía SaaS auth.
 * @param {Object} loginData - { username, password } (campo username mapeado a email)
 */
export const loginUser = async (loginData) => {
  try {
    const response = await axios.post('/api/v1/auth/login', {
      email: loginData.username,
      password: loginData.password,
    });
    return response.data; // { access_token, token_type, expires_in, refresh_token }
  } catch (error) {
    const detail = error.response?.data?.detail;
    throw new Error(Array.isArray(detail) ? detail.map((e) => e.msg).join('. ') : detail || 'Error al iniciar sesión');
  }
};

/**
 * Registra un nuevo usuario.
 */
export const registerUser = async (userData) => {
  try {
    const response = await apiClient.post('/v1/auth/register', {
      email: userData.email ?? userData.username,
      password: userData.password,
      full_name: userData.full_name ?? (userData.email ?? '').split('@')[0],
    });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail;
    let message;
    if (Array.isArray(detail)) {
      // Pydantic validation errors — extract human-readable messages
      message = detail.map((e) => e.msg).join('. ');
    } else {
      message = detail || 'Error al registrar usuario';
    }
    throw new Error(message);
  }
};

/**
 * Obtiene el usuario actualmente autenticado.
 */
export const getCurrentUser = async () => {
  try {
    const response = await apiClient.get('/users/me');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Error al obtener usuario');
  }
};
